require("expose-loader?$!expose-loader?jQuery!jquery");
require("expose-loader?animateNumber!./animateNumber");
require("expose-loader?Typed.new!./typed.js");
require("expose-loader?waterwheelCarousel!./jQuery-Waterwheel-Carousel/js/jquery.waterwheelCarousel.js");

require('jquery-ui-css/slider.css');
require("expose-loader?slider!jquery-ui/slider");
require("jquery-ui-touch-punch");

require("expose-loader?tinycolor!tinycolor2");

//normalize.css
require("normalize.css/normalize.css")
// require("expose-loader?scrollorama!./scrollorama/js/jquery.scrollorama.js");

// require("expose-loader?Vue!vue");
import Vue from 'vue';
window.Vue = Vue;
// require("expose-loader?mousewheel!jquery-mousewheel");
// require("expose-loader?carousel!./coverflowCarousel/scripts/jquery.carousel-1.1.min.js");
// require("./coverflowCarousel/style/carousel.css");
 
//swiper slider
require("swiper/dist/css/swiper.css");
require("expose-loader?Swiper!swiper/dist/js/swiper.jquery.js");


// WEBPACK FOOTER //
// ./vendor/vendor.js